<template>
  <div class="pd20x flex1">
    <addCoursedetail :visible="visible" @close="visible = false" :edit="editItem" :data="currentItem" @update="getData"></addCoursedetail>
    <div class="h100pct ofA">
      <div class="filter pd20x mb10x">
        <div>科目名称 : {{name}}</div>
        <div>
          <a-button type="primary" @click="()=>{ currentItem = {courseid:classId} ; editItem= false ;visible = true }">添加</a-button>
        </div>
      </div>
      <a-spin :spinning="loading">
        <div class="dragTable">
          <div class="dragHeader">
            <div class="iconTh"></div>
            <div class="flex1">类型</div>
            <div class="flex1">名称</div>
            <div class="flex1">价格</div>
            <div class="flex1">操作</div>
          </div>
          <draggable handle=".dragIcon" :list="result" v-if="result.length" @change="log">
            <div class="dragBody" v-for="(item, index) in result" :key="index">
              <div class="iconTh">
                <i class="dragIcon"></i>
              </div>
              <div class="flex1">
                <span v-if="item.type == 1">
                  <a-tag color="blue">
                    课程
                  </a-tag>
                </span>
                <span v-if="item.type == 2">
                  <a-tag color="orange">
                    资料
                  </a-tag>
                </span>
              </div>
              <div class="flex1">
                {{item.name}}
              </div>
              <div class="flex1">
                {{item.price}}
              </div>
              <div class="flex1">
                <a-button type="primary" style="margin-right:10px" @click="()=>{currentItem = item ;editItem =true; visible = true}">修改</a-button>
                <a-button type="primary" ghost style="margin-right:10px" @click="deleteItem(item.id)">删除</a-button>
              </div>
            </div>
          </draggable>
          <div id="qrcode"></div>
          <div v-if="!result.length && !loading" style="padding:20px 0;text-align:center;background:#fff">
            暂无数据
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import * as http from '@/libs/analysis'
import addCoursedetail from '@/components/analysis/addCoursedetail'
export default {
  name: 'unitList',
  components: { addCoursedetail },
  data(){
    return{
      result: [],
      visible: false,
      editItem: false,
      loading: true,
      currentItem: null,
      name: '',
      classId : ''
    }
  },
  mounted(){
    if (this.$route.query.class)
      this.classId = this.$route.query.class;
    if (this.$route.query.name)
      this.name = this.$route.query.name;
    this.$nextTick(()=>{
      this.getData()
    })
  },
  methods:{
    getData(){
      this.loading = true
      http.get_course_section({id:this.classId}).then(res=>{
        this.loading = false
        this.result = res
        this.qrcode()
      }).catch(error=>{
        this.loading = false
        console.log(error)
      })
    },
    handleChange(){

    },
    onSelectChange(){

    },
    addItem(){
      this.visible = true;
      this.currentItem = null
    },
    deleteItem(id){
      let _this = this
      this.$confirm({
        title: '是否确定删除项目?',
        centered: true,
        onOk() {
          http.del_course_section({id}).then(res=>{
            _this.getData()
          }).catch(error=>{
            console.log(error)
          })
        },
      });
    },
    log(){
      let result = { ids:this.result.map(el=>el.id).join(',')};
      http.order_course_section(result).then(res=>{

      }).catch(error=>{
        this.$message.error('拖拽失败，请重新操作');
        this.getData();
        console.log(error)
      })
    },
    hideModal(){

    }
  }
}
</script>
<style lang="less" scoped>

</style>
